import { Box, Grid, IconButton, TextField } from "@mui/material";
import { useStyles } from "../../../style/styles";
import { IProps } from "./types";
import { sendChannelMessage } from "../../lib/utils";
import { useState } from "react";


const ChatInput = (props: IProps) => {
  const classes = useStyles()
  const { channel, user, onFocus, onSendMessage } = props
  const [message, setMessage] = useState('')
  const [textInputFocused, setTextInputFocused] = useState(false)

  const searchParams = window.location.search
  const params = new URLSearchParams(searchParams)
  const sourceApp = params.get("sourceApp") ?? ''

  const checkMessageSubmission = (e: any) => {
    /* TODO: add checking for confirmation prompt (only for ended conversations) */
    handleNewMessageSubmit(e)
  }

  const handleNewMessageSubmit = async (e: any) => {
    setMessage('')
     if (e && typeof e.preventDefault === 'function') e.preventDefault();
    let trimmedMessage = message?.trim()
    const sentMessage = await sendChannelMessage(user, channel, trimmedMessage, false, sourceApp)
    onSendMessage?.(true)
    /* TODO: TJSKR-2780 (append <a> tag to link in message submission)*/
  }

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    /* Allow typing without showing the prompt if the user ended the conversation */
    setMessage(event.target.value)
  };

  const handleFocus = () => {
    props.onFocus(true)
    setTextInputFocused(true)
  }

  const handleBlur = () => {
    props.onFocus(false)
    setTextInputFocused(false)
  }

  return (
    <div className={classes.chatInputWeb}>
    {/* TODO: add conditional rendering for mobile (jobseeker) */}
    <Grid container direction='row' height='inherit' justifyContent='flex-start' alignItems="center" padding='1px 24px 1px 24px' width='100%' sx={{ position: 'relative' }}>
      <Box sx={{ position: 'absolute', bottom: 0, left: '5px', width: '95%', padding: '5px', display: 'flex' }}>
        <TextField
            variant="outlined"
            sx={{
              boxSizing: 'border-box',
              width: '100%',
              borderRadius: '5px',
              resize: 'none',
              backgroundColor: 'white'
            }}
            autoFocus
            fullWidth
            // ref={textInputRef}
            placeholder="Write a Message"
            value={message}
            onChange={handleChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
            InputProps={{
              style: {
                minHeight: '45px',
                whiteSpace: 'pre-line',
              },
            }}
            multiline
            minRows={1}
            maxRows={10}
            // disabled={isTextFieldDisabled}
          />

          <Grid item sx={{ padding: '0px 8px', display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
            <IconButton
              sx={{ padding: '0px', marginBottom: '8px' }}
              color="primary"
              onClick={checkMessageSubmission}
              // disabled={isSendDisabled}
            >
              <img
                src={
                  // isSendDisabled ?
                  // "/images/Send-disabled.svg" :
                  "/images/Send.svg"
                }
                alt="Send message"
                width={22}
                height={22}
              />
            </IconButton>
          </Grid>
      </Box>
    </Grid>
    </div>
  )
}

export default ChatInput